import { OnInit, Component, OnDestroy, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjectService } from 'src/app/service/api';
import { environment } from 'src/environments/environment';
import { Project } from 'src/app/common/interfaces/project.interface';
import { Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Component({
  templateUrl: 'email-invite.component.html',
  styleUrls: ['email-invite.component.scss'],
})
export class EmailInviteComponent implements OnInit, OnDestroy {
  public loginLink =
    environment.api +
    '/oauth2/authorization/samsung' +
    '?redirect_uri=' +
    window.location.protocol +
    '//' +
    window.location.host;
  public project = {} as Project;
  public member_type: string;
  private sub: Subscription;

  constructor(
    private projectService: ProjectService,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    const gnbElement = this.document.getElementById('gnb');
    gnbElement.style.display = 'none';

    this.sub = this.route.params.subscribe((params) => {
      this.findProjectByProjectID(params['id']);

      if (params['memberType'] === 'member') {
        this.member_type = 'a member';
      } else {
        this.member_type = 'as an owner';
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  findProjectByProjectID(projectID) {
    this.projectService.getProject(projectID).subscribe(
      (res: any) => (this.project = res),
      (err) => console.error(err)
    );
  }
}
